/** Profil-URL innerhalb der FC-App (BrowserRouter basename=/fightclub). */
export function profilePath(username) {
  if (!username) return "/profile";
  return `/profile/${encodeURIComponent(String(username).trim())}`;
}
